<div class="support-topics-faq-bottom-sheet">
  <div class="support-topics-faq-bottom-sheet__header">
    <h2 class="support-topics-faq-bottom-sheet__title">
      {{ data.topic.labelKey | translateLang }}
    </h2>
    <button
      type="button"
      class="support-topics-faq-bottom-sheet__close-button"
      (click)="close()"
      aria-label="Close"
    >
      <img
        src="/assets/images/icons/close-button-red.svg"
        width="24"
        height="24"
        alt=""
        class="support-topics-faq-bottom-sheet__close-icon"
      />
    </button>
  </div>

  <div class="support-topics-faq-bottom-sheet__list">
    @for (faq of data.topic.faqs; track faq.questionKey; let i = $index) {
      <div
        class="support-topics-faq-bottom-sheet__item"
        [class.support-topics-faq-bottom-sheet__item--expanded]="expandedIndex() === i"
      >
        <button
          type="button"
          class="support-topics-faq-bottom-sheet__item-header"
          (click)="toggleFaq(i)"
          [attr.aria-expanded]="expandedIndex() === i"
        >
          <span class="support-topics-faq-bottom-sheet__item-badge">{{ i + 1 }}</span>
          <span class="support-topics-faq-bottom-sheet__item-question">{{
            faq.questionKey | translateLang
          }}</span>
          <img
            class="support-topics-faq-bottom-sheet__item-chevron"
            [src]="
              expandedIndex() === i
                ? '/assets/images/icons/faq-chevron-up.svg'
                : '/assets/images/icons/faq-chevron-down.svg'
            "
            width="24"
            height="24"
            alt=""
          />
        </button>
        @if (expandedIndex() === i) {
          <p class="support-topics-faq-bottom-sheet__item-answer">
            {{ faq.answerKey | translateLang }}
          </p>
        }
      </div>
    }
  </div>
</div>
